import styled from 'react-emotion'
import { ellipsisOverflow } from 'styles/type'

const Title = styled.h4`
  margin-bottom: 0;
  ${ellipsisOverflow};
`

export default Title



// WEBPACK FOOTER //
// ./src/components/PageHeader/Title.js